import { useEffect, useState } from "react";

import useDataBean from "../../../core/services/dataBean/useDataBean";
import { CashReimbursementServices } from "../cellEditor/CashDesk/CashReimbursement/CashReimbursement-service";
import { toast } from "react-toastify";
import { Singleton } from "../../../core/services/Singleton";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { BasicPage } from "../../theme/Component/BasicPage";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AccountantConcept, _FiscalResponsability, _FiscalResponsabilityType } from "../../../core/services/dataBean/EntityCatalog";
import { _AdquisitionProject, _ArticleClassType, _DocumentTypeC, _MeasurementUnitCode, _Project, _TypeNeed } from "../../../core/services/dataBean/EntityCatalogVdos";
import useModal, { MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { SelectFunctionalID } from "../../admin/configuracion/functionalID/SelectFunctionalID";





export const TypeNeed = () => {

    const typeNeed = useDataBean(_TypeNeed);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Atención!', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const modalEditar = useModal("Agregar Proyecto", MODAL_md);


    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        typeNeed.instance.getTypeNeedCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        typeNeed.setBean({
            State: 1,
            Since: single.getCurrenDate(),
            // IDEmployee: single.getAccountID(),

        });
        setSwich(false);
        modalEditar.setModal({ ...modalEditar.modal, "view": true });
    }

    const editaItem = () => {
        //console.log(DocumentType.bean);
        typeNeed.update().then(
            (resp: any) => {
                getLista();
                modalEditar.setModal({ ...modalEditar.modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        typeNeed.bean.State = 2;
        //console.log(DocumentType.bean);
        editaItem();
        setModalC({ ...modalC, 'view': false });
    }




    const head = [
        { title: 'ID', property: 'IDTypeNeed', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Area', property: 'IDLnFunctionalID', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { modalEditar.setModal({ ...modalEditar.modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            // { titulo: 'Beneficiarios', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setbeneficiario({ ...beneficiario, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <BasicPage titulo="Catalogo de consolidación">
            <div className="row">

                <div className="col-md-12">


                    <BasicTable body={lista} head={head} rowSet={typeNeed.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={editaItem}>
                        <>
                            <div className="row">

                                <div className="col-md-6">
                                    <label>Nombre</label>
                                    <input type="text" name="Name" className="form-control" value={typeNeed.bean.Name} onChange={typeNeed.handleChange} />

                                </div>


                                <div className="col-md-6">

                                    <SelectFunctionalID functionalIDLn={typeNeed.bean.IDLnFunctionalID} onChange={(e: any) => { typeNeed.setBean({ ...typeNeed.bean, "IDLnFunctionalID": e?.IDLn }) }} />
                                </div>


                            </div>

                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}